module.exports = __webpack_public_path__ + "img/symbol_7.7e9c5d2a.png";